"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyOpacityToColor = exports.getPresetColorsForProperty = void 0;
var colord_1 = require("colord");
var getPresetColorsForProperty = function (property, colorProvider) {
    if (typeof property.presetColors === "undefined" || property.presetColors === "themeColors") {
        return colorProvider.themeColors;
    }
    if (typeof property.presetColors === "object") {
        return property.presetColors;
    }
    return colorProvider.filteredThemeColors;
};
exports.getPresetColorsForProperty = getPresetColorsForProperty;
var applyOpacityToColor = function (color, opacity) {
    var colorValue = "abs" in color ? color.abs : color.value;
    return (0, colord_1.colord)(colorValue).alpha(opacity).toRgbString();
};
exports.applyOpacityToColor = applyOpacityToColor;
